
















































// Importing components
import BasePagination from '@/base/BasePagination.vue';
import BaseButton from '@/ui/BaseButton.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
import TheTableRestaurants from '@/components/restaurants/TheTableRestaurants.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing function
import {getRestaurants} from '@/ts/restaurants/get-restaurants';

export default {
    name: 'PageUsers',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableRestaurants,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: Array(),
            search_param: String(),
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setCurrentPage', page);
            this.$store.dispatch('setLoadingOn');
            // Fetching data from the API
            getRestaurants().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        onSubmit() {
            this.$store.dispatch('setQueryParam', this.search_param);
            this.$store.dispatch('setLoadingOn');
            // Fetching data from the API
            getRestaurants().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
        }];

        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        this.$store.dispatch('setLastPage', 1);
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getRestaurants().finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
